import { RouterModule, Routes } from '@angular/router';
import { LoginCubeShopComponent } from './pages/login-v2/login-v2/login-cubeshop/login-cubeshop.component';
import { ResponsiveComponent } from './pages/home/responsive/responsive.component'
import { LoginRecoverPasswdCSComponent } from './pages/login-v2/login-recover-passwd-cs/login-recover-passwd-cs.component';
import { RegisterCubeShopUserComponent } from './pages/login-v2/login-v2/create-cubeshop-user/register-cubeshop-user.component';
import { AuthGuard } from './auth/auth-guard';

// Solo las rutas del portal de clientes. Las ~150 rutas del ERP que venian de newcube
// se quitaron: un cliente nunca llega a ellas (el login siempre manda a /cs-portal).
const APP_ROUTES: Routes = [
  // Public routes — no auth required
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginCubeShopComponent },
  { path: 'actPass', component: ResponsiveComponent },
  { path: 'RecoverPasswordCS', component: LoginRecoverPasswdCSComponent },
  // Registro publico OCULTO (2026-10-13): /createuser vuelve al login. Para reactivarlo:
  // { path: 'createuser', component: RegisterCubeShopUserComponent },
  { path: 'createuser', redirectTo: '/login', pathMatch: 'full' },

  // Protected routes — AuthGuard applied to parent, fires on every navigation through it
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'cs-portal',
        loadChildren: () => import('./pages/cs-portal/cs-portal.module').then(m => m.CsPortalModule)
      },
      {
        path: 'cs-serviceWorkOrder',
        loadChildren: () => import('./pages/cs-portal/cs-service-work-order/cs-service-work-order.module').then(m => m.CsServiceWorkOrderModule)
      },
      {
        path: 'cs-serviceSite',
        loadChildren: () => import('./pages/cs-portal/cs-service-sites/cs-service-sites.module').then(m => m.CsServiceSitesModule)
      },
      {
        path: 'cs-serviceSiteAssets',
        loadChildren: () => import('./pages/cs-portal/cs-service-sites-assets/cs-service-sites-assets.module').then(m => m.CsServiceSitesAssetsModule)
      },
      {
        path: 'openserviceSites',
        loadChildren: () => import('./pages/cs-portal/cs-portal-grids/cs-porta-grid-Service-Sites/open-service-sites.module').then(m => m.OpenServiceSitesModule)
      },
      {
        path: 'cs-activeProjects',
        loadChildren: () => import('./pages/cs-portal/cs-active-projects/cs-active-projects.module').then(m => m.CsActiveProjectsModule)
      },
      {
        path: 'cs-editServiceSites',
        loadChildren: () => import('./pages/cs-portal/cs-edit-service-sites/cs-edit-service-sites.module').then(m => m.CsEditServiceSitesModule)
      },
      {
        path: 'cs-serviceHistory',
        loadChildren: () => import('./pages/cs-portal/cs-service-history/cs-service-history.module').then(m => m.CsServiceHistoryModule)
      },
      {
        path: 'cs-cubeboxsites',
        loadChildren: () => import('./pages/cs-portal/cube-box/cs-cubebox-sites.module').then(m => m.OpenCubeboxModule)
      },
      {
        // Recommendations abre aca el PDF de la cotizacion (ViewPDF)
        path: 'reportviewer',
        loadChildren: () => import('src/app/shared/report-viewer/report-viewer.module').then(m => m.ReportViewerModule)
      },
      // Cualquier link heredado del ERP (/swo, /editProject, /services-map…) vuelve al dashboard
      { path: '**', redirectTo: '/cs-portal' },
    ]
  }
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES, {});
